import { render } from "./import-export-count.vue?vue&type=template&id=36b96f3d&scoped=true"
import script from "./import-export-count.vue?vue&type=script&lang=js"
export * from "./import-export-count.vue?vue&type=script&lang=js"

import "./import-export-count.vue?vue&type=style&index=0&id=36b96f3d&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b96f3d"]])

export default __exports__